/**
 * Transform an object by recursively applying fieldwise transformations
 *
 * ```
 * const data = [
 *     { name: "Bob", birthDate: "1984-09-26" },
 *     { name: "John", birthDate: "1965-05-12" }
 * ];
 *
 * const transform = fieldwiseTransform({
 *     birthDate: LocalDate.parse,
 * });
 *
 * const transformed = transform(data);
 *
 * transformed[0].birthDate.day === 26;
 * transformed[1].birthDate.day === 12;
 * ```
 *
 * @param converters An object with
 */
export function fieldwiseTransform(converters) {
    return applyReviver.bind(null, createReviver(converters));
}
/**
 * Function for generating "reviver"-functions for JSON.parse
 *
 * ```
 * JSON.parse(jsonString, createReviver({
 *     gyldigFra: LocalDate.parse,
 * }));
 * ```
 */
function createReviver(converters) {
    return function (key, value) { return (converters[key] && value != null ? converters[key](value) : value); };
}
/**
 * Applies a reviver function to an object the same way JSON.parse would, i.e.
 * recursively with (key, value) and the current object as this.
 *
 * Code based on the public domain reference implementation of JSON.parse
 */
function applyReviver(reviver, parsedJson) {
    function walk(holder, key) {
        var val = holder[key];
        if (val && typeof val === 'object') {
            for (var k in val) {
                if (Object.prototype.hasOwnProperty.call(val, k)) {
                    var v = walk(val, k);
                    if (v !== undefined) {
                        val[k] = v;
                    }
                    else {
                        delete val[k];
                    }
                }
            }
        }
        return reviver.call(holder, key, val);
    }
    return walk({ '': parsedJson }, '');
}
